import {removeElements} from "../auth-misc-functions.js";
import {authElements} from "../auth-account-elements.js";



/**
 * Реакция на клик по кнопке "Войти на сайт" на странице сплеш-авторизации
 * Очищает сообщения для пользователя (если они были)
 * Проверяет поставлено ли согласие с пользовательским соглашением
 * Проверяет заполненность формы, отправляет ее и выводит сообщение об обработке данных
 * Если форма не заполнена - подсвечивает ошибки
 * Далее ответ ловим в init_account.js в window.addEventListener('message'...
 *
 * @returns {void}
 */
const handleAuthSubmit = () => {
    removeElements('.g-message');

    const agreementCheckBox = document.getElementById('agreement-checkbox');

    // Проверка согласия (ранний возврат, если галочки нет)
    if (agreementCheckBox && !agreementCheckBox.checked) {
        authElements.authRegistration?.insertAdjacentHTML(
            'beforeend',
            '<div class="g-message g-message--error">Требуется согласие с Пользовательским соглашением</div>'
        );
        return;
    }

    // Проверка валидности формы
    if (authElements.ttAuthForm && !authElements.ttAuthForm.checkValidity()) {
        authElements.ttAuthForm.reportValidity();
        return;
    }

    // Успешный сценарий: все проверки пройдены
    authElements.ttAuthForm?.requestSubmit();

    // Блокируем кнопку
    if (authElements.ttAuthBtn) {
        authElements.ttAuthBtn.disabled = true;
    }

    authElements.authRegistration?.insertAdjacentHTML(
        'beforeend',
        '<div class="g-message">Обработка данных...</div>'
    );
}

export default handleAuthSubmit;